// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Role } from "../../data/identity/role";
import { ClaimType } from "../../data/identity/claim-type";
import { UserDocument } from "./documents/user-document";
import { ItemEnvelope } from "./base/item-envelope";

export class UserEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "User");
		if (jsonEnvelope) {
			this.Roles = jsonEnvelope.Roles;
			this.ClaimTypes = jsonEnvelope.ClaimTypes;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public Roles: Role[] = [];
	public ClaimTypes: ClaimType[] = [];
	public override Document: UserDocument = new UserDocument();
	public override get ItemId(): number { return this.Document.Item.UserId; }
	public override get ItemName(): string { return this.Document.Item.UID; }
}